import { render, staticRenderFns } from "./BlogRegions.vue?vue&type=template&id=3523b830&"
import script from "./BlogRegions.vue?vue&type=script&lang=js&"
export * from "./BlogRegions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3523b830')) {
      api.createRecord('3523b830', component.options)
    } else {
      api.reload('3523b830', component.options)
    }
    module.hot.accept("./BlogRegions.vue?vue&type=template&id=3523b830&", function () {
      api.rerender('3523b830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/BlogRegions.vue"
export default component.exports